// 업로드 직전 이미지 자동 압축 — HTML5 Canvas 기반 (추가 패키지 없음)
// 쇼링사진 등 컨테이너 선적서류 첨부 시 50MB 한도 초과 방지 + 디스크 절약 목적
//
// 동작:
//   - 이미지가 아닌 파일(PDF, Excel 등): 원본 그대로 반환
//   - 1.5MB 미만 이미지: 압축 효과 미미 → 원본 반환
//   - 1920px 초과 이미지: 최대 1920px 로 리사이즈
//   - JPEG quality 0.8 로 재인코딩 → 평균 5~10x 절감
//   - canvas 에서 decode 실패(HEIC 등): 원본 반환 (서버 measurement 유지)
//   - 압축 후 크기가 원본보다 큰 경우: 원본 반환

var MAX_DIMENSION = 1920;
var JPEG_QUALITY = 0.8;
var SKIP_UNDER_BYTES = 1.5 * 1024 * 1024;

function compressImage(file) {
  if (!file || !file.type) return Promise.resolve(file);
  if (file.type.indexOf('image/') !== 0) return Promise.resolve(file);
  if (file.size < SKIP_UNDER_BYTES) return Promise.resolve(file);

  return new Promise(function(resolve) {
    var img = new Image();
    var url = URL.createObjectURL(file);

    img.onload = function() {
      try { URL.revokeObjectURL(url); } catch(e) {}
      var w = img.width || 0;
      var h = img.height || 0;
      if (!w || !h) { resolve(file); return; }

      var scale = Math.min(1, MAX_DIMENSION / Math.max(w, h));
      var targetW = Math.round(w * scale);
      var targetH = Math.round(h * scale);

      var canvas = document.createElement('canvas');
      canvas.width = targetW;
      canvas.height = targetH;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, targetW, targetH);

      canvas.toBlob(function(blob) {
        if (!blob || blob.size >= file.size) {
          resolve(file);
          return;
        }
        var newName = (file.name || 'image').replace(/\.[^.]+$/, '') + '.jpg';
        try {
          var out = new File([blob], newName, { type: 'image/jpeg', lastModified: Date.now() });
          resolve(out);
        } catch(e) {
          // 구형 브라우저(File 생성자 미지원) fallback — Blob 을 file-like 로 반환
          blob.name = newName;
          blob.lastModifiedDate = new Date();
          resolve(blob);
        }
      }, 'image/jpeg', JPEG_QUALITY);
    };

    img.onerror = function() {
      try { URL.revokeObjectURL(url); } catch(e) {}
      resolve(file);
    };

    img.src = url;
  });
}

function compressFiles(files) {
  var list = files ? Array.from(files) : [];
  return Promise.all(list.map(function(f) { return compressImage(f); }));
}

module.exports = { compressImage: compressImage, compressFiles: compressFiles };
